// extracted by mini-css-extract-plugin
module.exports = {"header":"pliki-module--header--1hqDo","filesList":"pliki-module--filesList--zBhx3","filesListItem":"pliki-module--filesListItem--3jYEz","file":"pliki-module--file--2jfQ4"};